<app-base-modal
  [title]="'Файлы карты продукта'"
>
  @for (item of productCardImagesStateService.productCardImagesState(); track $index) {
    <app-file-card
      [fileCard]="{
        id: item.id,
        fileParams: item.file,
        fileType: productCardImagesDialogData.type,
        isEditModeActive: isEditModeActive,
        shouldCheckImageType: false
      }"
      (handleDelete)="handleDelete($event, item)"
    />
  }
  <app-file-upload-card
    [fileUploadParams]="{
      recordId: productCardImagesDialogData.recordId,
      parentId: productCardImagesDialogData.parentId,
      type: productCardImagesDialogData.type,
      entityFileType: 'RECORD_CALENDAR'
    }"
    [isEditModeActive]="isEditModeActive"
    (attachFile)="attachFile($event)"
  />
</app-base-modal>
